import { useEffect, useRef, useState } from "react";
import { f7, Fab, FabButton, FabButtons, Icon } from "framework7-react";
import { useBackClose } from "../hooks/use-back-close";

// Closed here instead of via fabClose: the speed dial's back entry then hands
// over to the popup in the same render instead of popping and pushing history.
const FabAction = ({ title, description, ios, md, onClick }) => (
  <FabButton
    label={
      <>
        <div className="fab-action-title">
          <b>{title}</b>
        </div>
        <div>{description}</div>
      </>
    }
    onClick={(event) => {
      f7.fab.close();
      onClick(event);
    }}
  >
    <Icon ios={ios} md={md} />
  </FabButton>
);

// Render as a direct <Page> child with slot="fixed", or it scrolls (AGENTS.md).
const HomeFab = ({ onEditGroup, onAddPayment, onAddExpense }) => {
  const wrapperRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useBackClose(isOpen, () => f7.fab.close());

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const open = () => setIsOpen(true);
    const close = () => setIsOpen(false);
    wrapper.addEventListener("fab:open", open);
    wrapper.addEventListener("fab:close", close);
    return () => {
      wrapper.removeEventListener("fab:open", open);
      wrapper.removeEventListener("fab:close", close);
    };
  }, []);

  return (
    <div className="fab-wrapper" ref={wrapperRef}>
      <Fab position="right-bottom">
        <Icon ios="f7:plus" md="material:add" />
        <Icon ios="f7:xmark" md="material:close" />
        <FabButtons position="top">
          <FabAction
            title="Gruppe bearbeiten"
            description="Name ändern oder Personen bearbeiten"
            ios="f7:person_badge_plus"
            md="material:person_add"
            onClick={onEditGroup}
          />
          <FabAction
            title="Zahlung erfassen"
            description="Jemand hat Geld zurückgezahlt"
            ios="f7:arrow_right_arrow_left"
            md="material:swap_horiz"
            onClick={onAddPayment}
          />
          <FabAction
            title="Neue Ausgabe"
            description="Jemand hat etwas ausgegeben"
            ios="f7:cart_badge_plus"
            md="material:shopping_basket"
            onClick={onAddExpense}
          />
        </FabButtons>
      </Fab>
      <div className="fab-overlay" onClick={() => f7.fab.close()} />
    </div>
  );
};

export default HomeFab;
